import { GraduationCap, Building2, Heart } from "lucide-react";
import { WHY_CHOOSE } from "@/data/siteData";

const iconMap = { GraduationCap, Building2, Heart };

export default function WhyChoose() {
  return (
    <section className="relative py-24 md:py-32 bg-[#EEF5F9]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="overline">Perché sceglierlo</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 text-[#0B4A5A] tracking-tight">
            Un approccio clinico rigoroso, con umanità.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {WHY_CHOOSE.map((item, i) => {
            const Icon = iconMap[item.icon];
            return (
              <div
                key={item.title}
                className="group bg-white border border-gray-100 rounded-2xl p-10 hover:border-[#C6A86B]/30 hover:shadow-[0_10px_40px_rgba(11,74,90,0.06)] transition-all duration-500"
                style={{ animationDelay: `${i * 80}ms` }}
              >
                <div className="icon-halo">
                  <Icon size={22} strokeWidth={1.4} />
                </div>
                <h3 className="font-serif text-2xl mt-6 text-[#0B4A5A]">
                  {item.title}
                </h3>
                <p className="mt-3 text-gray-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
